
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/lending/guide",
      function () {
        return require("private-next-pages/use-cases/lending/guide.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/lending/guide"])
      });
    }
  